import React from "react";
import {
  Dialog as MuiDialog,
  DialogContent,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./ShareChallengeDialog.module.css";
import { FaWhatsapp, FaLinkedin, FaFacebook, FaTwitter } from "react-icons/fa";
import { FiCopy, FiDownload } from "react-icons/fi";

const ShareChallengeDialog = ({ open, onClose, challenge }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleCopyLink = () => {
    navigator.clipboard.writeText(challenge.challengeLink);
    // You could add a toast notification here
  };

  const handleShare = (platform) => {
    let shareUrl = "";
    const challengeUrl = challenge.challengeLink;
    const title = `Join me for the ${challenge.title}`;

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          title + " " + challengeUrl
        )}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          challengeUrl
        )}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          challengeUrl
        )}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          title
        )}&url=${encodeURIComponent(challengeUrl)}`;
        break;
      default:
        break;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  };

  if (!challenge) return null;

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{
        style: {
          borderRadius: "16px",
          maxWidth: "400px",
        },
      }}
    >
      <DialogContent className={styles.dialogContent}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          className={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>

        <div className={styles.dialogHeader}>
          <h2>Share Challenge</h2>
        </div>

        <div className={styles.challengeCard}>
          {challenge.image && (
            <div className={styles.challengeImage}>
              <img src={challenge.image} alt={challenge.title} />
            </div>
          )}
          <div className={styles.challengeInfo}>
            <h3>{challenge.title}</h3>
            <p className={styles.dateRange}>
              {challenge.startDate} - {challenge.endDate}
            </p>
            <p className={styles.price}>{challenge.price}</p>
          </div>
        </div>

        <div className={styles.shareIcons}>
          <button
            className={styles.shareButton}
            onClick={() => handleShare("whatsapp")}
            aria-label="Share on WhatsApp"
          >
            <FaWhatsapp />
          </button>
          <button
            className={styles.shareButton}
            onClick={() => handleShare("twitter")}
            aria-label="Share on Twitter"
          >
            <FaTwitter />
          </button>
          <button
            className={styles.shareButton}
            onClick={() => handleShare("linkedin")}
            aria-label="Share on LinkedIn"
          >
            <FaLinkedin />
          </button>
          <button
            className={styles.shareButton}
            onClick={() => handleShare("facebook")}
            aria-label="Share on Facebook"
          >
            <FaFacebook />
          </button>
          <button
            className={styles.shareButton}
            onClick={() => handleCopyLink()}
            aria-label="Copy link"
          >
            <FiDownload />
          </button>
        </div>

        <div className={styles.linkContainer}>
          <div className={styles.linkBox}>
            <p className={styles.linkText}>{challenge.challengeLink}</p>
            <button
              className={styles.copyButton}
              onClick={handleCopyLink}
              aria-label="Copy link"
            >
              <FiCopy />
            </button>
          </div>
        </div>
      </DialogContent>
    </MuiDialog>
  );
};

export default ShareChallengeDialog;
